import IconCar from '/shared/images/icons/icon-car.svg';
import IconVan from '/shared/images/icons/icon-van.svg';
import IconHGV from '/shared/images/icons/icon-hgv.svg';
import SuvIcon from '/shared/images/commutesCar.svg';
import TaxiIcon from '/shared/images/icons/business-taxi.svg';
import RailIcon from '/shared/images/icons/business-rail.svg';
import BikeIcon from '/shared/images/icons/business-bike.svg';
import BusStop from '/shared/images/icons/bp-bus-stop-bp-green.svg';
import planeIcon from '/shared/images/icons/bp-airplane-jet-pictograms-bp-green-.svg';

const icons: Record<string, string> = {
  car: IconCar,
  cars: IconCar,
  van: IconVan,
  vans: IconVan,
  hgv: IconHGV,
  truck: IconHGV,
  busStop: BusStop,
  busCoach: BusStop,
  taxi: TaxiIcon,
  bike: BikeIcon,
  rail: RailIcon,
  airPlane: planeIcon,
  commutesCar: SuvIcon,
};

export default icons;
